import * as Popover from "@radix-ui/react-popover";
import { t } from "../../i18n";
import { ButtonIcon } from "../ButtonIcon";
import { TextIcon } from "../icons";

export const LofiFontMenuTrigger = () => {
  return (
    <Popover.Trigger asChild>
      <div>
        <ButtonIcon
          standalone
          icon={TextIcon}
          title={t("labels.showFonts")}
          className="properties-trigger"
          testId={"lofi-font-menu-trigger"}
          onClick={() => {}}
        />
      </div>
    </Popover.Trigger>
  );
}; 